import { BookingDetailsModalLoader } from "../BookingDetailsModalLoader";
import { BookingDetailsView } from "./BookingDetailsView";

export function renderBookingDetailsViewModal() {
  return (
    <BookingDetailsModalLoader
      className={"t_booking_details_view"}
      getAriaLabel={(bookingNo) => `View booking ${bookingNo}`}
      render={(props) => <BookingDetailsView {...props} />}
    />
  );
}
